module.exports = __webpack_public_path__ + "static/img/product_banner_13_zh.151daac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_13_zh.png
// module id = AMX0
// module chunks = 34